/*!
 * Based on articles on
 * https://gomakethings.com
 */

var drawer = function () {
  if (window.location.pathname === "/cart") return;
  /**
   * Element.closest() polyfill
   * https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#Polyfill
   */
  if (!Element.prototype.closest) {
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
    }
    Element.prototype.closest = function (/** @type {string} */ s) {
      var el = this;
      var ancestor = this;
      if (!document.documentElement.contains(el)) return null;
      do {
        if (ancestor.matches(s)) return ancestor;
        ancestor = ancestor.parentElement;
      } while (ancestor !== null);
      return null;
    };
  }

  // Trap Focus
  // https://hiddedevries.nl/en/blog/2017-01-29-using-javascript-to-trap-focus-in-an-element
  //
  /**
   * @param {HTMLElement} element
   */
  function trapFocus(element) {
    var focusableEls = element.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])'
    );
    var firstFocusableEl = focusableEls[0];
    var lastFocusableEl = focusableEls[focusableEls.length - 1];
    var KEYCODE_TAB = 9;

    element.addEventListener(
      "keydown",
      function (
        /** @type {{ key: string; keyCode: number; shiftKey: any; preventDefault: () => void; }} */ e
      ) {
        var isTabPressed = e.key === "Tab" || e.keyCode === KEYCODE_TAB;

        if (!isTabPressed) {
          return;
        }

        if (e.shiftKey) {
          /* shift + tab */ if (document.activeElement === firstFocusableEl) {
            lastFocusableEl.focus();
            e.preventDefault();
          }
        } /* tab */ else {
          if (document.activeElement === lastFocusableEl) {
            firstFocusableEl.focus();
            e.preventDefault();
          }
        }
      }
    );
  }

  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  //
  // Settings
  //
  var settings = {
    speedOpen: 50,
    speedClose: 350,
    activeClass: "is-active",
    visibleClass: "is-visible",
    selectorTarget: "[data-drawer-target]",
    selectorTrigger: "[data-drawer-trigger]",
    selectorClose: "[data-drawer-close]",
  };

  //
  // Methods
  //

  // Toggle accessibility
  var toggleAccessibility = function (/** @type {Element} */ event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  // Open Drawer
  var openDrawer = async function (/** @type {Element} */ trigger) {
    // Get cart data
    const cartData = await getCartData();

    await updateCartData(cartData);

    // Find target
    var target = document.getElementById(trigger.getAttribute("aria-controls"));

    // Make it active
    target.classList.add(settings.activeClass);

    // Make body overflow hidden so it's not scrollable
    document.documentElement.style.overflow = "hidden";

    // Toggle accessibility
    toggleAccessibility(trigger);

    // Make it visible
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
      trapFocus(target);
    }, settings.speedOpen);

    // trigger rebuy resize event
    resizeWindow();
  };

  // Close Drawer
  var closeDrawer = function (/** @type {Element} */ event) {
    // Find target
    var closestParent = event.closest(settings.selectorTarget),
      childrenTrigger = document.querySelector(
        '[aria-controls="' + closestParent.id + '"'
      );

    // Make it not visible
    closestParent.classList.remove(settings.visibleClass);

    // Remove body overflow hidden
    document.documentElement.style.overflow = "";

    // Toggle accessibility
    toggleAccessibility(childrenTrigger);

    // Make it not active
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  // Click Handler
  var clickHandler = function (
    /** @type {{ target: any; preventDefault: () => void; }} */ event
  ) {
    // Find elements
    var toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);

    // Open drawer when the open button is clicked
    if (open) {
      openDrawer(open);
    }

    // Close drawer when the close button (or overlay area) is clicked
    if (close) {
      closeDrawer(close);
    }

    // Prevent default link behavior
    if (open || close) {
      event.preventDefault();
    }
  };

  // Keydown Handler, handle Escape button
  var keydownHandler = function (
    /** @type {{ key: string; keyCode: number; }} */ event
  ) {
    if (event.key === "Escape" || event.keyCode === 27) {
      // Find all possible drawers
      var drawers = document.querySelectorAll(settings.selectorTarget);

      // Find active drawers and close them when escape is clicked
      for (let i = 0; i < drawers.length; ++i) {
        if (drawers[i].classList.contains(settings.activeClass)) {
          closeDrawer(drawers[i]);
        }
      }
    }
  };

  //
  // Our Functions
  //

  /**
   * @param {any} cartData
   */
  async function updateCartVisibility(cartData) {
    const cart = cartData ? cartData : await getCartData();
    const cartFooter = document.querySelector("[data-cart-footer]");
    const rebuyWidget = document.querySelector("[data-rebuy-id]");

    if (cartFooter) {
      if (cart.item_count > 0) {
        cartFooter.classList.remove("hidden");
        rebuyWidget.classList.remove("hidden");
      } else {
        cartFooter.classList.add("hidden");
        rebuyWidget.classList.add("hidden");
      }
    }
  }

  /**
   * @param {any} cartData
   */
  async function updateFreeShippingProgress(cartData) {
    const cart = cartData ? cartData : await getCartData();

    const freeShipping = document.querySelector("[data-free-shipping]");
    const progressText = document.querySelector(".free-shipping-progress");
    const progressCompleteText = document.querySelector(
      ".free-shipping-complete"
    );
    const progressBar = document.querySelector(".free-shipping-progress-bar");

    
    const freeShippingTotal = document.querySelector(".free-shipping-progress").getAttribute('data-threshold');
    const cost_diff = freeShippingTotal - parseInt(cart.total_price);

    if (cost_diff > 0) {
      freeShipping.innerText = centsToDollars(cost_diff);
      progressText.style.display = "block";
      progressCompleteText.style.display = "none";
    } else {
      progressText.style.display = "none";
      progressCompleteText.style.display = "block";
    }

    progressBar.style.width = `${Math.min(
      (parseInt(cart.total_price) / freeShippingTotal) * 100,
      100
    )}%`;
  }

  /**
   * @param {any} cartData
   */
  async function updateCartMessage(cartData) {
    const cart = cartData ? cartData : await getCartData();
    const cartMessage = document.querySelector(".drawer__content__message");

    if (cartMessage) {
      if (parseInt(cart.item_count) > 0) {
        return cartMessage.classList.add("hidden");
      } else {
        cartMessage.classList.remove("hidden");
      }
    }
  }

  /**
   * @param {any} cartData
   */
  async function updateCartCount(cartData) {
    const cart = cartData ? cartData : await getCartData();
    const cartCount = document.querySelectorAll(".cart-count");

    if (cartCount) {
      Array.from(cartCount).map((el) => (el.innerText = cart.item_count));
    }
  }

  async function getCartData() {
    try {
      const res = await fetch("/cart.js");
      const data = await res.json();

      return data;
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * @param {number} cents
   */
  function centsToDollars(cents) {
    const dollars = cents / 100;
    return dollars.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }

  /**
   * @param {any} cartData
   */
  async function updateSubtotal(cartData) {
    const cart = cartData ? cartData : await getCartData();
    const subtotal = centsToDollars(cart.total_price);
    document.querySelector("[data-cart-subtotal]").textContent = subtotal;
  }

  /**
   * @param {any} data
   */
  async function updateCartData(data) {
    await updateSubtotal(data);
    await populateCartData(data);
    await updateCartVisibility(data);
    await updateCartMessage(data);
    await updateCartCount(data);
    await updateFreeShippingProgress(data);
  }

  /**
   * @param {{ id: any; quantity: number; }} item
   */
  async function addCartItem(item) {
    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(item),
      });
      const data = await res.json();
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @param {{ [x: number]: number; }} updates
   */
  async function updateCart(updates) {
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });
      const data = await res.json();
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @param {any} id
   */
  async function removeItemByKey(id) {
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id, quantity: 0 }),
      });
      const data = await res.json();
      return data;
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @param {Event} e
   * @param {string} type
   */
  async function updateCartItemQty(e, type) {
    const currentQty = e.target.parentElement.querySelector(
      "[data-cart-item-input]"
    ).value;
    const dataset = e.target.closest("[data-cart-item-key").dataset;
    const key = dataset.cartItemKey;
    const currentVariantId = dataset.cartItemVariantId;
    const variants = JSON.parse(dataset.cartItemVariants);
    const sellingPlanId = dataset.cartItemSellingPlan;
    let newQuantity = parseInt(currentQty);

    if (type === "inc") {
      newQuantity += 1;
    } else if (type == "dec") {
      newQuantity -= 1;
    } else if (type == "set") {
      newQuantity = parseInt(e.target.value);
    } else {
      return;
    }

    // Get the new variant with quantity
    const newQtyVariant = variants.find(
      (/** @type {{ title: string; }} */ v, /** @type {number} */ i) => {
        const lowerBound = parseInt(v.title.split("+")[0]);
        const upperBound = parseInt(variants[i + 1]?.title.split("+")[0]);

        if (upperBound) {
          return lowerBound <= newQuantity && newQuantity < upperBound;
        } else {
          return lowerBound <= newQuantity;
        }
      }
    );

    if (newQtyVariant && currentVariantId != newQtyVariant.id) {
      // Upgrade/downgrade variant price tier
      // Add upgraded variant
      const itemData = { id: newQtyVariant.id, quantity: newQuantity };
      if (sellingPlanId != "undefined") itemData.selling_plan = sellingPlanId;
      const upgradedItem = await addCartItem(itemData);
      // Remove current variant
      const data = await removeItemByKey(key);
      await updateCartData(data);
    } else {
      // Add item to current price tier
      const itemData = { [key]: newQuantity };
      const data = await updateCart(itemData);
      await updateCartData(data);
    }
  }

  /**
   * @param {{ target: { closest: (arg0: string) => { (): any; new (): any; dataset: { (): any; new (): any; cartItemKey: any; }; }; }; }} e
   */
  async function removeCartItem(e) {
    const key = e.target.closest("[data-cart-item-key]").dataset.cartItemKey;

    const settings = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id: key, quantity: 0 }),
    };

    try {
      const res = await fetch("/cart/change.js", settings);
      const data = await res.json();
      await updateCartData(data);
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * @param {string} key
   * @param {string?} val
   */
  function productStorage(key, val = undefined) {
    return val === undefined
      ? localStorage.getItem(key)
      : localStorage.setItem(key, val);
  }

  /**
   * @param {{ title: any; image: any; url: any; final_price: any; final_line_price: any; quantity: any; selling_plan_allocation: any; variant_id: any; key: any; handle: any; properties: any; }} item
   */
  async function cartItem(item) {
    const {
      title,
      image,
      url,
      final_price,
      final_line_price,
      quantity,
      selling_plan_allocation,
      variant_id,
      key,
      handle,
      properties,
    } = item;

    let variants = productStorage(handle);

    if (!variants) {
      const res = await fetch(`/products/${handle}.json`);
      const { product } = await res.json();
      variants = JSON.stringify(product.variants);
      productStorage(handle, variants);
    }

    const propertiesArr = Object.entries(properties || {})
      .filter((prop) => prop[0].substring(0, 1) !== "_")
      .map((prop) => prop[1]);

    const variantIndex = JSON.parse(variants).findIndex(variant => variant.id === variant_id)


    return `
      <li 
        class="border-b border-light-gray flex py-2rem first:pt-0" 
        data-cart-item-variant-id="${variant_id}" 
        data-cart-item-key="${key}"
        data-cart-item-variants='${variants}'
        data-cart-item-selling-plan="${selling_plan_allocation?.selling_plan?.id
      }"
      >
			<div class="flex flex-col items-center justify-between">
        <div class="drawer__cart-item__img-container">
          <img
            src="${image}" 
            alt="${title}"
          >
        </div>
				
       		<button data-cart-item-remove class="mt-1.6rem w-2rem">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
              <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/>
              <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/>
            </svg>
					</button>
				</div>
        <div class="drawer__cart-item__info flex flex-col justify-between">
          <a href="${url}">
            <h3>${title.split("Plug")[0]}</h3>
            ${selling_plan_allocation
        ? `<p>${selling_plan_allocation.selling_plan.name}</p>`
        : ""
      }
          </a>
          ${JSON.parse(variants)?.length > 1 &&
        JSON.parse(variants)?.length - 1 !== variantIndex &&
        JSON.parse(variants)[0]?.title.includes("+")
        ? `<span class="text-blue block tracking-wide font-thin">* Buy more, save more</span>`
        : `<span></span>`
      }
          <div>
            ${propertiesArr
        .map(
          (prop) =>
            `<span class="text-blue text-[1.2rem] block tracking-wide font-thin">${prop}</span>`
        )
        .join("")}
          </div>
          <div class="drawer__cart-item__info__qty">
            <button 
              type="button" 
              data-cart-item-dec
            >
              <svg class="mh1 select-none pointer-events-none" role="presentation" viewBox="0 0 16 2" fill="#98B23B" width="8" height="8">
                <path d="M1,1 L15,1" stroke="currentColor" stroke-width="3" fill="none" fill-rule="evenodd" stroke-linecap="square"></path>
              </svg>
            </button>
            <input 
              type="number" 
              value="${quantity}"
              min="0"
              data-cart-item-input
            >
            <button 
              type="button" 
              data-cart-item-inc
            >
              <svg class="mh1 select-none pointer-events-none" role="presentation" viewBox="0 0 16 16" fill="#98B23B" width="8" height="8">
                <g stroke="currentColor" fill="none" fill-rule="evenodd" stroke-width="3" stroke-linecap="square"><path d="M8,1 L8,15"></path> <path d="M1,8 L15,8"></path></g>
              </svg>
            </button>
          </div>
        </div>
				<div class="flex-1 flex flex-col items-end justify-between font-thin">
          <span class="text-1.6rem">
            ${quantity > 1 ? centsToDollars(final_price) + "/ea" : ""}
          </span>
          <span class="text-2rem">${centsToDollars(final_line_price)}</span>
        </div>
      </li>
    `;
  }

  /**
   * @param {any} cartData
   */
  async function populateCartData(cartData) {
    const cart = cartData ? cartData : await getCartData();
    const cartList = document.querySelector(".drawer__content__list");

    const promises = cart.items.map(
      async (/** @type {any} */ item, /** @type {string | number} */ i) =>
        await cartItem(cart.items[i])
    );
    const cartItems = await Promise.all(promises);

    cartList.innerHTML = cartItems.join("");

    // attach remove buttons
    const removeBtns = document.querySelectorAll("[data-cart-item-remove]");

    removeBtns.forEach(function (btn) {
      btn.addEventListener("click", removeCartItem);
    });

    // attach dec/inc buttons
    const decBtns = document.querySelectorAll("[data-cart-item-dec]");
    const incBtns = document.querySelectorAll("[data-cart-item-inc]");
    const qtyInputs = document.querySelectorAll("[data-cart-item-input]");

    decBtns.forEach(function (btn) {
      btn.addEventListener("click", async function (e) {
        btn.disabled = true;
        await updateCartItemQty(e, "dec");
        btn.disabled = false;
      });
    });

    incBtns.forEach(function (btn) {
      btn.addEventListener("click", async function (e) {
        btn.disabled = true;
        await updateCartItemQty(e, "inc");
        btn.disabled = false;
      });
    });

    // attach keyup input qty
    qtyInputs.forEach(function (input) {
      input.addEventListener(
        "keyup",
        debounce(function (/** @type {any} */ e) {
          updateCartItemQty(e, "set");
        }, 1000)
      );
    });
  }

  //
  // Add method to open cart drawer globally
  //
  window.openCartDrawer = function () {
    const trigger = document.querySelector("[data-drawer-trigger]");
    openDrawer(trigger);
    return;
  };

  //
  // Inits & Event Listeners
  //
  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);

  // Rebuy flyout cart listeners
  document.addEventListener("rebuy.add", async function () {
    const data = await getCartData();
    await updateCartData(data);
  });

  function resizeWindow() {
    if (typeof Event === "function") {
      // modern browsers
      window.dispatchEvent(new Event("resize"));
    } else {
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      var evt = window.document.createEvent("UIEvents");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
    }
  }

  document.addEventListener("rebuy.productsChange", function () {
    // trigger rebuy resize event
    resizeWindow();
  });
};

drawer();
